/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GitUserInfoParser = /* #__PURE__ */ parsers.object([
    ['username', codecString],
    ['name', codecString],
]);
export class GitUserInfo extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GitUserInfoParser.decode(input).map(res => new GitUserInfo(res));
    }
    static unsafeDecode(input) {
        return GitUserInfo.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GitUserInfoParser.encode(data);
    }
    static schema() {
        return GitUserInfoParser.schema();
    }
}
